module.exports = __webpack_public_path__ + "img/a18.c13f3b89.svg";